<div 
  [ngClass]="{contentCard: !isMini, contentSmallCard: isMini}" 
  class="contentCardContainer dws-elevation-z1" 
  [style.width.px]="forceSize ? 270 : 'auto'"
  [style.height.px]="forceSize ? (isMini ? 100 : 180) : 'auto'">
  
  <div class="contentCardNumber">
    <mat-icon *ngIf="icon" aria-hidden="false">{{ icon }}</mat-icon>
    <span *ngIf="bigValue">{{ bigValue }}</span>
    <span *ngIf="!bigValue"> - </span>
  </div>
  
  <div class="contentCardLabel">
    {{ subtitle }}
    <web-info-icon-hoverable *ngIf="tooltip"
      description="{{ tooltip }}"
      overrides="position: fixed; z-index:1000;transform: translate(0, 0); ">
    </web-info-icon-hoverable>
  </div>
  <div *ngIf="smallValue" class="contentCardSubNumber">{{ smallValue }}</div>
</div>
